<script setup lang="ts">
    import ProfileAutocomplete from "@/components/forms/reusables/ProfileAutocomplete.vue";
    import KRepeater from "@/components/forms/groups/Repeater/KRepeater.vue";
    import { defineProps, withDefaults, toRefs } from "vue";
    import { defaultRepeaterConverter } from "@/components/forms/groups/Repeater/helpers";

    interface Props {
        name: string;
        label?: string;
        add_label?: string;
        remove_label?: string;
        urlParams?: { [key: string]: unknown };
        onlyActive?: boolean;
        onlyPermitted?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        label: "Personal",
        add_label: "Lägg till personal",
        remove_label: "Ta bort personal",
        urlParams: () => ({}),
        onlyActive: true,
        onlyPermitted: true,
    });

    const { name, label, add_label, remove_label, urlParams, onlyActive, onlyPermitted } = toRefs(props);
</script>

<template>
    <KRepeater
        :name="name"
        :add-label="add_label"
        :remove-label="remove_label"
        :converter="defaultRepeaterConverter"
        #default="{ index, model }"
    >
        <ProfileAutocomplete
            name="id"
            :label="label"
            :urlParams="urlParams"
            :onlyActive="onlyActive"
            :onlyPermitted="onlyPermitted"
            :value="model?.[index]?.id ?? null"
        />
    </KRepeater>
</template>

<style scoped lang="scss"></style>
